(function () {
  'use strict';
  
  if (window._spInit) return;
  window._spInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SKU = 'PROTECT';
  var ROUTE_SKU = 'ROUTEINS';
  var busy = false;
  var _userUnchecked = false;

  var cfg = { variantId: null, enabled: false, minThreshold: 0, maxThreshold: 100, pct: 3, flatFee: 1.95 };

  function loadConfig() {
    var el = document.getElementById('shipping-protection-cart') ||
             document.getElementById('shipping-protection-cart-drawer');
    if (!el) return;
    cfg.enabled      = el.getAttribute('data-enabled') === 'true';
    cfg.variantId    = (el.getAttribute('data-variant-id') || '').trim() || null;
    cfg.minThreshold = parseFloat(el.getAttribute('data-min-threshold')) || 0;
    cfg.maxThreshold = parseFloat(el.getAttribute('data-max-threshold')) || 100;
    cfg.pct          = parseFloat(el.getAttribute('data-insurance-percentage')) || 3;
    cfg.flatFee      = parseFloat(el.getAttribute('data-flat-fee')) || 1.95;
  }


  function fetchCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function findProtection(items) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].sku === SKU) return items[i];
    }
    return null;
  }
      
  function realItems(items) {
    return items.filter(function (it) { return it.sku !== SKU && it.sku !== ROUTE_SKU; });
  }

  function isGiftCardItem(item) {
    var t = (item.product_type || '').toLowerCase();
    var n = (item.product_title || item.title || '').toLowerCase();
    return t.indexOf('gift card') !== -1 || t.indexOf('gift-card') !== -1 ||
           n.indexOf('gift card') !== -1 || n.indexOf('gift-card') !== -1;
  }

  function hasEligible(items) {
    var real = realItems(items);
    for (var i = 0; i < real.length; i++) {
      if (!isGiftCardItem(real[i])) return true;
    }
    return false;
  }

  function subtotalCents(items) {
    var total = 0, real = realItems(items);
    for (var i = 0; i < real.length; i++) {
      if (isGiftCardItem(real[i])) continue;
      total += real[i].original_line_price || real[i].final_line_price || (real[i].price * real[i].quantity);
    }
    return total;
  }

  function estimatePrice(cents) {
    var d = cents / 100;
    return d <= cfg.maxThreshold ? cfg.flatFee : Math.round(d * (cfg.pct / 100) * 100) / 100;
  }


  function isBuyAgainFlow() {
    var search = window.location.search || '';
    var referrer = document.referrer || '';
    return search.indexOf('cart_link_id') !== -1 ||
           referrer.indexOf('orders') !== -1 ||
           referrer.indexOf('account') !== -1;
  }


  function showCartLoader() {
    if (document.getElementById('sp-cart-loader')) return;
    var overlay = document.createElement('div');
    overlay.id = 'sp-cart-loader';
    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.95);z-index:9999;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:1rem;';
    overlay.innerHTML = '<div style="width:40px;height:40px;border:3px solid rgba(0,0,0,0.1);border-top-color:rgba(0,0,0,0.7);border-radius:50%;animation:sp-spin 0.8s linear infinite;"></div><div style="font-size:1.1rem;color:rgba(0,0,0,0.7);">Loading cart...</div>';
    if (!document.getElementById('sp-spin-style')) {
      var s = document.createElement('style');
      s.id = 'sp-spin-style';
      s.textContent = '@keyframes sp-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(s);
    }
    document.body.appendChild(overlay);
  }

  function hideCartLoader() {
    var el = document.getElementById('sp-cart-loader');
    if (el) {
      el.style.opacity = '0';
      el.style.transition = 'opacity 0.3s';
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 350);
    }
  }

  // ── UI helpers ─────────────────────────────────────────────────────

  (function injectCSS() {
    if (document.getElementById('sp-css')) return;
    var s = document.createElement('style');
    s.id = 'sp-css';
    s.textContent =
      'body[data-sp-eligible="1"] .shipping-protection-cart{display:block!important;margin:1rem 0}' +
      'body:not([data-sp-eligible="1"]) .shipping-protection-cart{display:none!important}' +
      '.shipping-protection-price::after{content:var(--sp-price-text,"")}' +
      '.sp-msg-checked,.sp-msg-unchecked{display:none!important}' +
      '.shipping-protection-cart[data-sp-checked="1"] .sp-msg-checked{display:block!important}' +
      '.shipping-protection-cart[data-sp-checked="0"] .sp-msg-unchecked{display:block!important}';
    (document.head || document.documentElement).appendChild(s);
  })();

  var _lastChecked = false;

  function setVisible(show) {
    document.body.dataset.spEligible = show ? '1' : '0';
  }

  function applyCheckedState(checked) {
    _lastChecked = checked;
    var containers = document.querySelectorAll('.shipping-protection-cart');
    var val = checked ? '1' : '0';
    for (var j = 0; j < containers.length; j++) {
      containers[j].setAttribute('data-sp-checked', val);
    }
  }

  function syncCheckboxes(checked) {
    var boxes = document.querySelectorAll('.shipping-protection-checkbox');
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].checked = checked;
      boxes[i].disabled = false;
    }
    applyCheckedState(checked);
  }

  function disableCheckboxes() {
    var boxes = document.querySelectorAll('.shipping-protection-checkbox');
    for (var i = 0; i < boxes.length; i++) boxes[i].disabled = true;
  }

  function updatePrice(cents) {
    var price = estimatePrice(cents);
    setPriceText(price);
  }

  function updateActualPrice(protItem) {
    var priceCents = protItem.final_line_price || protItem.price || 0;
    setPriceText(priceCents / 100);
  }

  function setPriceText(dollars) {
    var text = dollars > 0 ? '"$' + dollars.toFixed(2) + '"' : '""';
    document.documentElement.style.setProperty('--sp-price-text', text);
  }

  function clearPrice() {
    document.documentElement.style.setProperty('--sp-price-text', '""');
  }

  function showEmptyCartState() {
    var isCartPage = window.location.pathname === '/cart' || window.location.pathname === '/cart/';

    if (isCartPage) {
      window.location.reload();
      return;
    }

    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) {
      var url = new URL(ROOT, window.location.origin);
      url.searchParams.set('section_id', 'cart-drawer');
      url.searchParams.set('_', Date.now().toString());
      fetch(url, { cache: 'no-store' })
        .then(function (res) { return res.ok ? res.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newDrawer = doc.querySelector('cart-drawer');
          if (newDrawer) {
            drawerEl.innerHTML = newDrawer.innerHTML;
          }
        }).catch(function () {});
    }

    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (bubble) bubble.style.display = 'none';
    var countEl = bubble && bubble.querySelector('span');
    if (countEl) countEl.textContent = '0';
  }


  (function initModal() {
    var modalId = 'sp-info-modal';
    var SP_MODAL_FONT = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"';

    function injectModalCSS() {
      if (document.getElementById('sp-modal-css')) return;
      var s = document.createElement('style');
      s.id = 'sp-modal-css';
      s.textContent =
        '@keyframes sp-scaleUp{from{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}' +
        '#sp-info-modal{width:100%;height:100%;display:none;box-sizing:border-box;padding:0 40px;' +
          'text-transform:none!important;font-family:' + SP_MODAL_FONT + '!important;' +
          'color:#818181;position:fixed;z-index:2147483647;top:0;left:0;' +
          'user-select:none;-webkit-user-select:none;opacity:0;' +
          '-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);' +
          'transition:opacity .5s cubic-bezier(.4,0,.2,1) 0ms}' +
        '#sp-info-modal.sp-open{display:flex;align-items:flex-start;justify-content:center;' +
          'background-color:rgba(0,0,0,.6);opacity:1}' +
        '#sp-info-modal *{box-sizing:border-box}' +
        '#sp-info-modal .sp-modal__container{display:flex;flex-direction:column;' +
          'background:linear-gradient(180deg,#f7f7f7,#fff 45%);border-radius:5px;' +
          'box-sizing:border-box;max-width:840px!important;max-height:calc(100% - 82px);' +
          'overflow-y:auto;outline:none;user-select:text;-webkit-user-select:text;' +
          'margin:auto;position:relative;text-align:center;align-items:center;' +
          'justify-content:center;animation:sp-scaleUp .5s cubic-bezier(.165,.84,.44,1) forwards}' +
        '#sp-info-modal .sp-modal__row-1{display:flex;justify-content:space-between;' +
          'align-items:center;width:100%;padding:16px 20px 0}' +
        '#sp-info-modal .sp-modal__powered-by{display:flex;align-items:center;gap:6px;' +
          'font-size:9px;font-weight:600;letter-spacing:1.2px;color:#6a6a6d;text-transform:uppercase}' +
        '#sp-info-modal .sp-modal__powered-by-logo{font-weight:700;font-size:11px;color:#6a6a6d;letter-spacing:.3px}' +
        '#sp-info-modal .sp-modal__close{cursor:pointer;background:none;border:none;padding:4px;' +
          'display:flex;align-items:center;justify-content:center;color:#6a6a6d}' +
        '#sp-info-modal .sp-modal__close:hover{color:#333}' +
        '#sp-info-modal .sp-modal__cont{padding:0 32px 0;user-select:text;-webkit-user-select:text;width:100%}' +
        '#sp-info-modal .sp-modal__row-2{margin-top:32px;margin-bottom:16px}' +
        '#sp-info-modal .sp-modal__title{display:flex;flex-direction:column;text-align:left;' +
          'justify-content:center;font-family:' + SP_MODAL_FONT + '!important;' +
          'font-size:28px;font-style:normal;font-weight:400;line-height:42px;color:#333}' +
        '#sp-info-modal .sp-modal__row-4{width:100%;text-align:left}' +
        '#sp-info-modal .sp-modal__content{font-family:' + SP_MODAL_FONT + '!important;' +
          'font-size:18px;font-style:normal;font-weight:400;line-height:28px;color:#333;' +
          'margin:0 0 16px}' +
        '#sp-info-modal .sp-modal__bullet-points{list-style:none;padding:0;margin:0 0 16px}' +
        '#sp-info-modal .sp-modal__bullet-point{display:flex;align-items:flex-start;gap:10px;margin-bottom:12px}' +
        '#sp-info-modal .sp-modal__bullet-image{flex-shrink:0;margin-top:8px}' +
        '#sp-info-modal .sp-modal__bp-content{text-align:left}' +
        '#sp-info-modal .sp-modal__bp-title{margin:0;font-family:' + SP_MODAL_FONT + '!important;' +
          'font-size:16px;font-weight:600;color:#333;line-height:24px}' +
        '#sp-info-modal .sp-modal__bp-desc{margin:2px 0 0;font-family:' + SP_MODAL_FONT + '!important;' +
          'font-size:14px;font-weight:400;color:#333;line-height:22px}' +
        '#sp-info-modal .sp-modal__footer{width:100%;border-top:1px solid rgba(216,216,216,.7);' +
          'display:flex;align-items:center;justify-content:center;flex-direction:column;' +
          'text-align:left;font-family:' + SP_MODAL_FONT + '!important;' +
          'font-size:12px;font-style:normal;font-weight:400;line-height:18px;' +
          'letter-spacing:-.2px;color:#545454;margin-top:24px;padding:16px 0 24px}' +
        '#sp-info-modal .sp-modal__footer-content{margin-bottom:12px;text-align:left;width:100%}' +
        '#sp-info-modal .sp-modal__footer-links{display:flex;gap:16px;flex-wrap:wrap;width:100%}' +
        '#sp-info-modal .sp-modal__footer-links a{color:#333;text-decoration:underline;font-size:12px;' +
          'font-family:' + SP_MODAL_FONT + '!important}';
      (document.head || document.documentElement).appendChild(s);
    }

    function getOrCreateModal() {
      var existing = document.getElementById(modalId);
      if (existing) return existing;
      injectModalCSS();

      var overlay = document.createElement('div');
      overlay.id = modalId;
      overlay.innerHTML =
        '<div class="sp-modal__container" role="dialog" aria-modal="true" tabindex="-1">' +
          '<div class="sp-modal__row-1">' +
            '<div class="sp-modal__powered-by">' +
              '<span>POWERED BY</span>' +
              '<span class="sp-modal__powered-by-logo">Mackenzie Limited</span>' +
            '</div>' +
            '<button class="sp-modal__close" aria-label="Close dialog">' +
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M15.1 2.3L13.7.9 8 6.6 2.3.9.9 2.3 6.6 8 .9 13.7 2.3 15.1 8 9.4 13.7 15.1 15.1 13.7 9.4 8"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
          '<div class="sp-modal__cont">' +
            '<div class="sp-modal__row-2">' +
              '<div class="sp-modal__title">We\'ve got you covered.</div>' +
            '</div>' +
            '<div class="sp-modal__row-4">' +
              '<p class="sp-modal__content">Shipping Protection gives you peace of mind while saving you time and money.</p>' +
              '<ul class="sp-modal__bullet-points">' +
                '<li class="sp-modal__bullet-point">' +
                  '<svg class="sp-modal__bullet-image" width="5" height="5" viewBox="0 0 5 5" xmlns="http://www.w3.org/2000/svg"><circle cx="2.5" cy="2.5" r="2.5" fill="#000"/></svg>' +
                  '<div class="sp-modal__bp-content">' +
                    '<h3 class="sp-modal__bp-title">Shipping Protection</h3>' +
                    '<p class="sp-modal__bp-desc">Coverage in case your package is damaged in transit, stolen, or doesn\'t arrive.</p>' +
                  '</div>' +
                '</li>' +
                '<li class="sp-modal__bullet-point">' +
                  '<svg class="sp-modal__bullet-image" width="5" height="5" viewBox="0 0 5 5" xmlns="http://www.w3.org/2000/svg"><circle cx="2.5" cy="2.5" r="2.5" fill="#000"/></svg>' +
                  '<div class="sp-modal__bp-content">' +
                    '<h3 class="sp-modal__bp-title">Quick Issue Resolution</h3>' +
                    '<p class="sp-modal__bp-desc">Get a resolution quickly with a few easy steps.</p>' +
                  '</div>' +
                '</li>' +
              '</ul>' +
            '</div>' +
            '<div class="sp-modal__footer">' +
              '<div class="sp-modal__footer-content">' +
                'Shipping Protection is an optional service offered directly by Mackenzie Limited. It is not an insurance policy. Coverage applies to eligible domestic shipments that are lost, damaged in transit, or stolen after confirmed delivery. Claims must be submitted within 10 days of the carrier\u2019s marked delivery date. Certain exclusions apply.' +
              '</div>' +
              '<div class="sp-modal__footer-links">' +
                '<a href="/pages/contact-us" target="_blank" rel="noopener noreferrer">Report a Problem</a>' +
                '<a href="/pages/privacy-policy" target="_blank" rel="noopener noreferrer">User Privacy</a>' +
                '<a href="/pages/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>' +
                '<a href="/pages/faqs" target="_blank" rel="noopener noreferrer">FAQs</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      document.body.appendChild(overlay);

      overlay.addEventListener('click', function (ev) {
        if (ev.target === overlay || ev.target.closest('.sp-modal__close')) {
          overlay.classList.remove('sp-open');
        }
      });
      return overlay;
    }

    document.addEventListener('click', function (e) {
      var info = e.target.closest ? e.target.closest('.shipping-protection-info') : null;
      if (!info) return;
      e.preventDefault();
      e.stopPropagation();
      var modal = getOrCreateModal();
      modal.classList.add('sp-open');
    });
  })();


  function getSectionParam() {
    var ids = [];
    var mc = document.querySelector('#main-cart-items');
    if (mc && mc.dataset.id) ids.push(mc.dataset.id);
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    return ids.join(',');
  }

  function resetUpsellButtons() {
    var buttons = document.querySelectorAll('.c-product-card__add');
    for (var i = 0; i < buttons.length; i++) {
      var span = buttons[i].querySelector('span');
      if (span) span.classList.remove('c-product-card__add-loading-spinner');
      var icon = buttons[i].querySelector('.c-icon-cart');
      if (icon) icon.style.display = '';
    }
    if (typeof window.ensureUpsellEventListeners === 'function') {
      window.ensureUpsellEventListeners();
    }
  }

  function replaceSections(sections) {
    if (!sections) return;
    for (var id in sections) {
      if (!sections.hasOwnProperty(id) || !sections[id]) continue;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');

      if (id === 'cart-drawer') {
        var nci = doc.querySelector('#CartDrawer-CartItems');
        var oci = document.querySelector('#CartDrawer-CartItems');
        if (nci && oci) oci.innerHTML = nci.innerHTML;

        var ndf = doc.querySelector('.cart-drawer__footer');
        var odf = document.querySelector('.cart-drawer__footer');
        if (ndf && odf) odf.innerHTML = ndf.innerHTML;
      }

      var ni = doc.querySelector('#main-cart-items');
      var oi = document.querySelector('#main-cart-items');
      if (ni && oi) oi.innerHTML = ni.innerHTML;

      var nf = doc.querySelector('#main-cart-footer');
      var of2 = document.querySelector('#main-cart-footer');
      if (nf && of2) of2.innerHTML = nf.innerHTML;
    }
    applyCheckedState(_lastChecked);
    resetUpsellButtons();
  }

  var lastCartItems = [];

  function cartPost(endpoint, body) {
    var sections = getSectionParam();
    if (sections) {
      body.sections = sections;
      body.sections_url = '/cart';
    }
    return fetch(ROOT + endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  function syncUI(cart) {
    if (!cart) return;
    loadConfig();
    lastCartItems = cart.items || [];
    var prot    = findProtection(cart.items);
    var elig    = hasEligible(cart.items);
    var cents   = subtotalCents(cart.items);
    var dollars = cents / 100;
    var show    = cfg.enabled && elig && dollars >= cfg.minThreshold;

    setVisible(show);
    if (show) {
      if (prot) {
        updateActualPrice(prot);
      } else {
        updatePrice(cents);
      }
    } else {
      clearPrice();
    }
    if (!busy) {
      syncCheckboxes(!!prot);
    }

    return { prot: prot, show: show, dollars: dollars };
  }

  function maybeAutoAdd(cart) {
    if (!cart || busy) return;
    var elig = hasEligible(cart.items);
    var attr = cart.attributes ? cart.attributes.shipping_protection : null;
    if (!elig) {
      _userUnchecked = false;
      if (attr === 'no') {
        cartPost('cart/update.js', { attributes: { shipping_protection: '' } }).catch(function () {});
      }
      return;
    }
    if (_userUnchecked || attr === 'no') return;
    var prot = findProtection(cart.items);
    if (prot) return;
    var cents = subtotalCents(cart.items);
    if (cents / 100 < cfg.minThreshold) return;
    if (!cfg.enabled || !cfg.variantId) return;
    applyCheckedState(true);
    syncCheckboxes(true);
    doAdd(cart);
  }

  function syncFromCart() {
    return fetchCart().then(function (cart) {
      if (!cart) return null;
      var state = syncUI(cart);
      if (state && state.prot && !state.show) {
        return doRemove(cart);
      }
      maybeAutoAdd(cart);
      return state;
    });
  }

  function quickSyncFromResponse(response) {
    try {
      var clone = response.clone();
      clone.json().then(function (data) {
        if (data && data.items && typeof data.item_count === 'number') {
          var state = syncUI(data);
          if (state && state.prot && !state.show) {
            doRemove(data);
          } else {
            maybeAutoAdd(data);
          }
        } else {
          syncFromCart();
        }
      }).catch(function () {
        syncFromCart();
      });
    } catch (e) {
      syncFromCart();
    }
  }


  var _pendingCheckout = false;
  var _busyAction = '';

  function restoreCheckoutButtons() {
    var btns = document.querySelectorAll('[name="checkout"]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].removeAttribute('disabled');
      if (btns[i]._origText) {
        var span = btns[i].querySelector('span') || btns[i];
        span.textContent = btns[i]._origText;
        btns[i]._origText = null;
      }
    }
  }

  function setBusy(val, error) {
    busy = val;
    if (!val && _pendingCheckout) {
      if (error) {
        _pendingCheckout = false;
        restoreCheckoutButtons();
      } else {
        _pendingCheckout = false;
        restoreCheckoutButtons();
        window.location.assign('/checkout');
      }
    }
  }

  document.addEventListener('click', function (e) {
    if (!busy) return;
    var btn = e.target.closest
      ? e.target.closest('[name="checkout"], a[href="/checkout"], a[href*="/checkout"]')
      : null;
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    _pendingCheckout = true;
    btn.setAttribute('disabled', 'disabled');
    var span = btn.querySelector('span') || btn;
    if (!btn._origText) btn._origText = span.textContent;
    span.textContent = _busyAction === 'remove' ? 'Removing protection\u2026' : 'Applying protection\u2026';
  }, true);

  function doAdd(existingCart) {
    if (!cfg.variantId || busy) return Promise.resolve();
    busy = true;
    _busyAction = 'add';
    disableCheckboxes();

    var cartPromise = existingCart ? Promise.resolve(existingCart) : fetchCart();
    return cartPromise.then(function (cart) {
      if (!cart) { setBusy(false, true); return; }
      var dollars = subtotalCents(cart.items) / 100;
      if (dollars < cfg.minThreshold) {
        syncUI(cart);
        setBusy(false);
        return;
      }
      if (findProtection(cart.items)) {
        return cartPost('cart/update.js', { attributes: { shipping_protection: 'yes' } })
          .then(function (data) {
            if (data && data.sections) replaceSections(data.sections);
            return fetchCart().then(syncUI);
          })
          .then(function () { setBusy(false); });
      }
      return cartPost('cart/update.js', { attributes: { shipping_protection: 'yes' } })
        .then(function () {
          return cartPost('cart/add.js', {
            items: [{ id: parseInt(cfg.variantId, 10), quantity: 1 }]
          });
        })
        .then(function (data) {
          if (data && data.sections) replaceSections(data.sections);
          return fetchCart().then(syncUI);
        })
        .then(function () {
          setBusy(false);
        });
    }).catch(function () {
      syncCheckboxes(false);
      setBusy(false, true);
    });
  }

  function doRemove(existingCart) {
    if (busy) return Promise.resolve();
    busy = true;
    _busyAction = 'remove';
    disableCheckboxes();

    var cartPromise = existingCart ? Promise.resolve(existingCart) : fetchCart();
    return cartPromise.then(function (cart) {
      if (!cart) { setBusy(false, true); return; }
      var item = findProtection(cart.items);
      var chain = Promise.resolve();

      if (item) {
        chain = chain.then(function () {
          return cartPost('cart/change.js', { id: item.key, quantity: 0 });
        }).then(function (data) {
          if (data && data.sections) replaceSections(data.sections);
          if (!data) {
            return fetchCart().then(function (freshCart) {
              if (!freshCart) return;
              var freshItem = findProtection(freshCart.items);
              if (!freshItem) return;
              return cartPost('cart/change.js', { id: freshItem.key, quantity: 0 })
                .then(function (retryData) {
                  if (retryData && retryData.sections) replaceSections(retryData.sections);
                });
            });
          }
        });
      }

      return chain.then(function () {
        return cartPost('cart/update.js', { attributes: { shipping_protection: 'no' } });
      }).then(function (data) {
        if (data && data.sections) replaceSections(data.sections);
        return fetchCart().then(syncUI);
      }).then(function () {
        setBusy(false);
        if (lastCartItems.length === 0) {
          showEmptyCartState();
        }
        setTimeout(function () {
          if (!busy) syncFromCart();
        }, 600);
      });
    }).catch(function () {
      syncCheckboxes(true);
      setBusy(false, true);
    });
  }


  function handleBuyAgainFlow(cart) {
    var prot = findProtection(cart.items);
    var attr = cart.attributes ? cart.attributes.shipping_protection : null;

    if (!prot) return Promise.resolve(false);
    if (attr === 'yes') return Promise.resolve(false);

    var cents = subtotalCents(cart.items);
    var dollars = cents / 100;
    var elig = hasEligible(cart.items);

    if (!elig || dollars < cfg.minThreshold) {
      return doRemove().then(function () { return true; });
    }

    busy = true;
    return cartPost('cart/update.js', { attributes: { shipping_protection: 'yes' } })
      .then(function (data) {
        if (data && data.sections) replaceSections(data.sections);
        return fetchCart();
      })
      .then(function (updatedCart) {
        if (updatedCart) syncUI(updatedCart);
        setBusy(false);
        return true;
      })
      .catch(function () {
        setBusy(false, true);
        return false;
      });
  }


  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.classList || !e.target.classList.contains('shipping-protection-checkbox')) return;
    if (busy) { e.preventDefault(); return; }
    var checked = e.target.checked;
    _userUnchecked = !checked;
    applyCheckedState(checked);
    syncCheckboxes(checked);
    if (checked) doAdd(); else doRemove();
  });

  // ── External cart change detection ─────────────────────────────────

  var _origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] :
              (arguments[0] && arguments[0].url ? arguments[0].url : '');
    var isCartMod = url.indexOf('/cart/change') !== -1 ||
                    url.indexOf('/cart/update') !== -1 ||
                    url.indexOf('/cart/add') !== -1 ||
                    url.indexOf('/cart/clear') !== -1;
    var result = _origFetch.apply(this, arguments);
    if (isCartMod) {
      result.then(function (r) {
        if (!busy) {
          quickSyncFromResponse(r);
        }
        setTimeout(function () {
          if (!busy) syncFromCart();
        }, 1000);
        setTimeout(function () {
          if (!busy) syncFromCart();
        }, 2500);
        return r;
      }).catch(function () {});
    }
    return result;
  };


  (function watchBodyReplacement() {
    var isCartPage = window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart') !== -1;
    if (!isCartPage) return;

    var _bodyObsTimer = null;
    var obs = new MutationObserver(function () {
      clearTimeout(_bodyObsTimer);
      _bodyObsTimer = setTimeout(function () {
        if (!busy) {
          loadConfig();
          syncFromCart();
        }
      }, 300);
    });
    obs.observe(document.body, { childList: true });
  })();

  function init() {
    loadConfig();

    if (!cfg.enabled) {
      setVisible(false);
      return;
    }
      
    var isCartPage = window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart') !== -1;

    fetchCart().then(function (cart) {
      if (!cart) {
        hideCartLoader();
        return;
      }
      
      var prot = findProtection(cart.items);
      var attr = cart.attributes ? cart.attributes.shipping_protection : null;

      if (prot && attr !== 'yes') {
        if (isCartPage) showCartLoader();
        handleBuyAgainFlow(cart).then(function () {
          hideCartLoader();
        });
      } else {
        var state = syncUI(cart);
        if (state && state.prot && !state.show) {
          doRemove(cart);
        } else {
          maybeAutoAdd(cart);
        }
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:drawer:opened', function () {
    if (!cfg.enabled || busy) return;
    syncFromCart();
  });

  document.addEventListener('cart:drawer:content-updated', function () {
    if (!cfg.enabled || busy) return;
    syncFromCart();
  });
})();
